export default ({ data }) => {
  let {
    orderText,
    title,
    content,
    template,
    paddingTop,
    paddingBottom,
    paddingRight,
    paddingLeft,
  } = data;

  if (template) {
    template = template
      .replace("{{orderText}}", orderText)
      .replace("{{title}}", title)
      .replace("{{content}}", content);
  }

  return (
    <div>
      {!!template ? (
        <section
          style={{
            paddingTop,
            paddingBottom,
            paddingRight,
            paddingLeft,
          }}
          dangerouslySetInnerHTML={{ __html: template }}
        ></section>
      ) : (
        <div>Default Content Block</div>
      )}
    </div>
  );
};
